<template>
  <div class="device">
    <div class="layout" style="margin-top: 95px">
      <div class="device-setting">
        <div
          class="layout-header"
          ref="searchBox"
          style="
            background: transparent;
            padding: 16px;
            width: calc(100% - 0.875rem);
          "
        >
          <div style="padding: 16px; background: #fff">
            <div class="layout-header-title">车位系数设置</div>
            <div class="layout-header-content">
              <div>
                车位系数值：<el-input
                  placeholder="请输入"
                  style="width: 80px"
                  size="small"
                  v-model="x"
                ></el-input>
              </div>
              <div style="margin-bottom: 32px">
                示例：长度为10米的站点，它的车位数为：<el-input
                  placeholder="请输入"
                  style="width: 80px"
                  size="small"
                  disabled
                  :value="Math.floor(10/x)"
                ></el-input>
                位
              </div>
              <el-button size="small" @click="x = null">清空</el-button>
              <el-button
                type="primary"
                size="small"
                @click="save"
                :disabled="!x"
                >保存</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
export default {
  name: 'siteparam',
  data() {
    return {
      x: null
    }
  },
  computed: {
    ...mapGetters(['selfAreaId', 'userSelectAddressData']),
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    },
    isAggregation() {
      // 是否是非复合区下的实体区
      return !(
        (this.aggregation == 0 && this.aggregationId == '') ||
        (this.aggregation == 1 && this.aggregationId)
      )
    }
  },
  created() {
    Api.getFactor(this.selfAreaId).then(({ data }) => {
      this.x = data.data || null
    })
  },
  methods: {
    save() {
      if (this.isAggregation) {
        this.$message.warning('复合区子区域无法添加，请在复合区添加！')
        return
      }
      if (Number(this.x) > 0) {
        Api.updateFactor(this.selfAreaId, this.x).then((data) => {
          if ((data.code = 200)) {
            this.$message.success('修改区域站点长度系统成功')
          }
        })
      }
    }
  }
}
</script>

<style lang="less" >
.layout-header-title {
  font-size: 20px;
  font-weight: bold;
  color: #111111;
  line-height: 24px;
  padding-bottom: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  border-bottom: 1px solid #ebebeb;
}
.layout-header-content {
  padding-top: 8px;
  > div {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 18px;
    margin-top: 16px;
  }
}
</style>
